module.exports = __webpack_public_path__ + "static/media/thorchain.e80ffd28.svg";